import { setAccountId } from '../../../../api/account'
import { LOCAL_AUTH_STORAGE_KEYS } from '../constants'
import { configureUserTimeZone } from '../../../utils/timeZone'
import { useWorkspaceUiStore } from '@/stores/useWorkspaceUiStore'
import { useUserStore } from '@/stores/useUserStore'
import {
  setStoredAccessToken,
  setStoredAccountId,
  setStoredRefreshToken,
} from './storage'

export const markUserInactive = () => {
  const { setUserInactive } = useWorkspaceUiStore.getState()

  setUserInactive(true)
}

export const persistLoginSession = (data: any) => {
  const user = data.user
  if (!user?.is_active) {
    markUserInactive()
    return false
  }

  const userDisplayName =
    user && user.first_name ? user.first_name + ' ' + user.last_name : ''
  const { setUserInactive } = useWorkspaceUiStore.getState()
  const { setUsername } = useUserStore.getState()

  setUserInactive(false)
  setUsername(userDisplayName)
  setAccountId(data.account ? data.account.id : null)

  if (data.refresh_token) {
    setStoredRefreshToken(data.refresh_token)
  }

  localStorage.setItem(LOCAL_AUTH_STORAGE_KEYS.userDisplayName, userDisplayName)
  localStorage.setItem(LOCAL_AUTH_STORAGE_KEYS.email, user ? user.email : '')

  localStorage.removeItem(LOCAL_AUTH_STORAGE_KEYS.showBreak)
  localStorage.setItem(LOCAL_AUTH_STORAGE_KEYS.user, JSON.stringify(user))
  configureUserTimeZone(user)
  setStoredAccessToken(data.token)
  setStoredAccountId(data.account ? String(data.account.id) : 'null')

  if (data.first_login) {
    localStorage.setItem(LOCAL_AUTH_STORAGE_KEYS.firstLogin, 'true')
  }
  if (data.webpush_url)
    localStorage.setItem(LOCAL_AUTH_STORAGE_KEYS.webpushUrl, data.webpush_url)

  return true
}
